// Hardcoded subdomain → agent ID mapping for infrastructure routing.
// Subdomains are stable (set via CloudFormation/DNS) and intentionally
// decoupled from the DB-backed agent catalogue. Add a new entry here
// whenever a new agent subdomain is provisioned.
const SUBDOMAIN_TO_AGENT_ID: Record<string, string> = {
  onboarding: 'onboarding-agent',
  optimize: 'optimize-clean-up-agent',
  migrate: 'pd_migration_assitant',
};

// Reverse mapping: agentId → login slug (the key used by AgentLoginView's AGENT_CONFIG).
// Keep in sync with SUBDOMAIN_TO_AGENT_ID above.
export const AGENT_ID_TO_LOGIN_SLUG: Record<string, string> = {
  'onboarding-agent': 'onboarding',
  'optimize-clean-up-agent': 'optimize',
  'pd_migration_assitant': 'migrate',
};

export type SubdomainContext =
  | { type: 'selector' }
  | { type: 'agent'; agentId: string }
  | { type: 'local' };

// 'agents' is deprecated — remove from this Set when the DNS entry is decommissioned
const SELECTOR_KEYS = new Set(['accelerate', 'engage', 'agents']);
const ENV_SUFFIX_RE = /-(test|stg)$/;

/**
 * Determines the active agent context from the current hostname.
 *
 * - accelerate[-test|-stg].fde.pagerduty.com → selector (primary)
 * - engage[-test|-stg].fde.pagerduty.com     → selector
 * - agents[-test|-stg].fde.pagerduty.com    → selector (deprecated)
 * - <subdomain>[-test|-stg].fde.pagerduty.com → single agent
 * - localhost / other → local (no restriction, full selector shown)
 */
export function getSubdomainContext(): SubdomainContext {
  const { hostname } = window.location;
  const rawKey = hostname.split('.')[0];
  const key = rawKey.replace(ENV_SUFFIX_RE, '');

  console.debug('[subdomain] hostname:', hostname);
  console.debug('[subdomain] rawKey:', rawKey, '→ normalised key:', key);

  if (!hostname.includes('.fde.pagerduty.com')) {
    console.debug('[subdomain] result: local (not an fde.pagerduty.com hostname)');
    return { type: 'local' };
  }

  if (SELECTOR_KEYS.has(key)) {
    console.debug('[subdomain] result: selector');
    return { type: 'selector' };
  }

  const agentId = SUBDOMAIN_TO_AGENT_ID[key];
  if (agentId) {
    console.debug('[subdomain] result: agent →', agentId);
    return { type: 'agent', agentId };
  }

  console.debug('[subdomain] result: local (key not in SUBDOMAIN_TO_AGENT_ID:', key, ')');
  return { type: 'local' };
}
